import { TouchableOpacity } from 'react-native';

export const TouchableItem = (TouchableOpacity as any) as typeof import('./TouchableItem.native').TouchableItem;
